/* Patches: CTA-knapparna pa produktsidan ska rulla upp till paketvaljaren i
   stallet for att ladda om samma sida.

   Lyssnaren ar delegerad pa dokumentet, sa den galler alla sektioner, aven
   sadana som laggs till i temaeditorn efterat. Den slar bara till nar lanken
   pekar pa sidan man redan star pa och paketvaljaren faktiskt finns i DOM:en.
   Pa startsidan finns ingen paketvaljare, och da navigerar lanken som vanligt. */
(function () {
  // Temats paketvaljare (snippets/patches-paket.liquid).
  var VALJARE = '#paketvaljare';

  function pekarPaSammaSida(a) {
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return false;
    var url;
    try {
      url = new URL(href, window.location.href);
    } catch (e) {
      return false;
    }
    if (url.origin !== window.location.origin) return false;
    var a1 = url.pathname.replace(/\/+$/, '');
    var a2 = window.location.pathname.replace(/\/+$/, '');
    return a1 === a2;
  }

  function headerHojd() {
    var h = document.querySelector('sticky-header, .header-wrapper, .section-header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.top <= 0 ? r.height : 0;
  }

  /* Scrollfilmen (sections/patches-scroll3d.liquid) ar flera skarmar hog. En
     mjuk rullning rakt igenom den spelade filmen i full fart med rutor som
     blixtrade forbi, och temats och var egen rullning krockade. Ett direkt
     hopp loste det men da sag man inte vart sidan tog vagen. Nu rullar vi
     sjalva, en enda mjuk rullning, och medan den passerar filmen tonas
     filmen ned till sin morka bakgrund (klassen p3d--forbi, se
     patches-scroll3d.js) - man ser sidan glida dit utan att filmen spelas. */
  function filmenIVagen(y) {
    var film = document.querySelector('.p3d');
    if (!film || !film.offsetHeight) return false;
    var fran = window.pageYOffset;
    var top = film.getBoundingClientRect().top + fran;
    var botten = top + film.offsetHeight;
    var lag = Math.min(fran, y), hog = Math.max(fran, y);
    return lag < botten && hog > top;
  }

  var pagaende = 0;
  function hoppaTill(y) {
    var rot = document.documentElement;
    var film = document.querySelector('.p3d');
    var fran = window.pageYOffset;
    var avst = Math.abs(y - fran);
    var tid = Math.min(1100, 450 + avst * 0.07);   // ms, langre vag tar lite langre tid
    var start = performance.now();
    var mitt = ++pagaende;
    var forr = rot.style.scrollBehavior;
    rot.style.scrollBehavior = 'auto';   // var egen animation, inte CSS:ens
    if (film) film.classList.add('p3d--forbi');
    var mjuk = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    function steg(nu) {
      if (mitt !== pagaende) return;            // en ny rullning har tagit over
      var t = Math.min(1, (nu - start) / tid);
      window.scrollTo(0, fran + (y - fran) * mjuk(t));
      if (t < 1) { requestAnimationFrame(steg); return; }
      rot.style.scrollBehavior = forr;
      if (film) setTimeout(function () { if (mitt === pagaende) film.classList.remove('p3d--forbi'); }, 150);
    }
    requestAnimationFrame(steg);
    // Kunden tar over med fingret/hjulet - slapp direkt.
    var avbryt = function () { pagaende++; rot.style.scrollBehavior = forr; if (film) film.classList.remove('p3d--forbi'); };
    window.addEventListener('wheel', avbryt, { once: true, passive: true });
    window.addEventListener('touchstart', avbryt, { once: true, passive: true });
  }

  function rullaTillY(y) {
    y = y < 0 ? 0 : y;
    if (filmenIVagen(y)) hoppaTill(y);
    else window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function malY(mal) {
    return mal.getBoundingClientRect().top + window.pageYOffset - headerHojd() - 12;
  }

  function rullaTill(mal) {
    rullaTillY(malY(mal));
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var a = t.closest('a[href]');
    if (!a || a.target === '_blank') return;

    // Ankarlankar pa sidan (t.ex. "226+ omdomen" -> #recensioner).
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) === '#' && href.length > 1) {
      var ankare = document.getElementById(decodeURIComponent(href.slice(1)));
      if (!ankare) return;
      var y = ankare.getBoundingClientRect().top + window.pageYOffset;
      if (!filmenIVagen(y)) return;   // inget i vagen - lat webblasaren rulla
      e.preventDefault();
      hoppaTill(y);
      return;
    }

    if (!pekarPaSammaSida(a)) return;
    var mal = document.querySelector(VALJARE);
    if (!mal || !mal.offsetHeight) return;

    e.preventDefault();
    rullaTill(mal);
  }, false);

  /* Den fasta kopraden langst ned ar temats egen <sticky-atc>. Den rullar dit
     data-scroll-destination pekar, och den star pa hela produktinformationen,
     alltsa hogst upp pa sidan. Malet ska vara paketvaljaren.

     Forsta forsoket var att fanga klicket och rulla sjalv, men temats egen
     lyssnare korde anda och skrev over positionen. Har pekas attributet om i
     stallet, sa temat rullar ratt av sig sjalvt.
     Attributet satts bade vid start och i capture-fasen vid klick, ifall
     blocket renderas om. */
  function pekaOmStickyAtc() {
    var mal = document.querySelector(VALJARE);
    if (!mal || !mal.id) return;
    var rader = document.querySelectorAll('sticky-atc[data-scroll-destination]');
    for (var i = 0; i < rader.length; i++) {
      rader[i].setAttribute('data-scroll-destination', '#' + mal.id);
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    if (!t.closest('.sticky-atc__scroll-btn')) return;
    pekaOmStickyAtc();

    var mal = document.querySelector(VALJARE);
    if (!mal || !mal.offsetHeight) return;

    /* Ligger filmen i vagen stoppas klicket har i capture-fasen, innan temats
       egen mjuka rullning hinner borja, och sidan hoppar direkt. */
    if (filmenIVagen(malY(mal))) {
      e.preventDefault();
      e.stopPropagation();
      hoppaTill(malY(mal));
      return;
    }

    /* Vi rullar sjalva strax efter klicket, och en gang till nar temats egen
       animation hunnit lagga sig. Gjorde temat redan ratt landar vi pa samma
       stalle, sa den andra rullningen syns inte. */
    setTimeout(function () { rullaTill(mal); }, 60);
    setTimeout(function () { rullaTill(mal); }, 420);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pekaOmStickyAtc);
  } else {
    pekaOmStickyAtc();
  }
  window.addEventListener('load', pekaOmStickyAtc);
})();
